
import dotenv from 'dotenv';
dotenv.config();


const server = process.env.REACT_APP_API_SERVER;
const imageServer = process.env.REACT_APP_IMAGE_SERVER;

const url = {

    imageUpload : imageServer.concat('/uploads/'),
    fileupload : imageServer.concat('/upload'),

    project : server.concat('/projects'),
    project_list : server.concat('/projects?sort=name&order=desc'),

    
    blogs : server.concat('/contents/blogs'),
    cards : server.concat('/contents/cards'),
    quizzes : server.concat('/contents/quizzes'),
    surveys : server.concat('/contents/surveys'),
    contents : server.concat('/contents'),

    organization : server.concat('/organization'),
    organization_delete : server.concat('/accounts'),
    invite : server.concat('/accounts/invite'),
    reInvite : server.concat('/accounts/invite/retry'),

    signin : server.concat('/auth/login'),
    signup : server.concat('/accounts'),
    passwordChange : server.concat('/me/password'),
    passwordReset : server.concat('/accounts/password/reset'),

    user_list : server.concat('/projects/'),

    delivery_list : server.concat('/users/'),
    
    schedule_create : server.concat('/programs'),
    schedule_update : server + '',
    schedule_read : server.concat('/programs'),
    schedule_delete : server.concat('/programs'),
    schedule_list : server.concat('/programs'),

    representives_create : server.concat('/projects'),
    representives_update : server.concat('/projects'),
    representives_read : server.concat('/projects/1'),
    representives_delete : server.concat('/projects'),
    representives_list : server.concat('/projects'),
    // {{url}}/projects/1/representives?sort=name&order=asc

    lowTag_create : server.concat('/representives'),
    lowTag_update : server.concat('/representives'),
    lowTag_read : server + '',
    lowTag_delete : server.concat('/representives'),
    lowTag_list : server.concat('/representives?sort=name&order=asc&page=-1'),

    forward : server.concat('/projects/')
}

export { url as default};
